import { urls } from '../../../../config';
import { apiRequest } from '../../apiRequest';
import { selfCancellingAction } from '../../selfCancellingAction';
import { DELETE_PREVIOUS_BOOKING, PREVIOUS_BOOKING } from './action-types';

export const [previousBookingLogin, cancelPreviousBookingLogin] = selfCancellingAction(
  (dispatch, bookingId, surname, postcode) => {
    return apiRequest(
      dispatch,
      PREVIOUS_BOOKING,
      urls.bookingAccount,
      { bookingId, surname, postcode },
      undefined,
      'post',
    );
  },
);

export const deletePreviousBooking = (dispatch) => {
  return dispatch({ type: DELETE_PREVIOUS_BOOKING });
};
